import swal from "sweetalert";

export const firePopup = (data) => {
  swal(
    data?data:
    "Please stay tuned, this function will be enabled shortly after the launch of full Startup onboarding process",
    { closeOnClickOutside: false }
  );
};
